module.exports = __webpack_public_path__ + "static/media/dico1.f17c7ff4.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/parcours/dico1.JPG
// module id = 146
// module chunks = 0